import { isProcessingSelector as isProcessingApiSelector } from 'state/api/authentication/AuthenticationApiSelectors';

export const errorsSelector = state => state.ui.login.errors;

export const isProcessingSelector = state => isProcessingApiSelector(state);